import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { RUN_WITH_DATASETS_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_run_with_datasets_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import useRunId from '@/hooks/useRunId.ts';

import { RunWithDatasets } from '@/types/runs.ts';

const useRetrieveRunWithDatasets = (): UseQueryResult<RunWithDatasets, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const runId = useRunId();

  return useQuery({
    queryKey: RUN_WITH_DATASETS_KEY(automationId, runId),
    queryFn: async () => {
      const response = await apiClient.get(get_run_with_datasets_url(runId));
      return response.data;
    },
    enabled: !!automationId && !!runId,
  });
};

export default useRetrieveRunWithDatasets;
